module.exports = __webpack_public_path__ + "img/beauty_clone.964beaa.svg";